import { useTranslation } from 'react-i18next'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuthContext } from '../context/auth/auth'
import { DecodedTokenTypes } from '../interfaces/decodedToken'
import setupInterceptor from '../services/setupInterceptor'

interface Props {
  requiredUserType: DecodedTokenTypes['user_type'] | undefined
}

const ProtectedRoute = ({ requiredUserType }: Props) => {
  const { t } = useTranslation()
  const { token, userType, logout } = useAuthContext()
  setupInterceptor({ logout, toastMsg: t('sessionExpired') })

  // The role is read from the token, not from the profile request, so a user
  // whose profile call fails is not treated as logged out.
  return token && userType === requiredUserType ? <Outlet /> : <Navigate to='/login' replace />
}

export default ProtectedRoute
